module.exports = __webpack_public_path__ + "img/progress-bar-oman.ff6c1471.svg";